import { FormEvent, useState } from 'react'

import Loader from 'content-components/_Primatives/Loader'
import Input from '../../Input'
import Button from '../../Button'
import useFormFields from '../../useFormFields'
import style from './style.scss'

const STATES = {
  DEFAULT: 'default',
  LOADING: 'loading',
  HAS_ERROR: 'has-error',
}

type LoginFormSubmitParams = {
  email: string
  password: string
}

type Props = {
  onSubmit: (params: LoginFormSubmitParams) => Promise<void>
  emailText: string
  passwordText: string
  forgotPasswordText: string
  buttonText: string
  errorText: string
}

function LoginForm({
  onSubmit,
  emailText,
  passwordText,
  forgotPasswordText,
  buttonText,
  errorText,
}: Props) {
  const [state, setState] = useState(STATES.DEFAULT)
  const { email, password, onChange } = useFormFields({
    email: '',
    password: '',
  })

  function handleSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault()
    setState(STATES.LOADING)
    onSubmit({ email, password }).catch(() => {
      setState(STATES.HAS_ERROR)
    })
  }

  function handleChange(event: FormEvent<HTMLInputElement>) {
    const { name, value } = event.currentTarget
    if (name === 'email' || name === 'password') {
      onChange({
        name,
        value,
      })
    }
  }

  if (state === STATES.LOADING) {
    return <Loader />
  }

  return (
    <form className={style.wrapper} onSubmit={handleSubmit}>
      <Input
        className={style.input}
        name='email'
        placeholder={emailText}
        type='text'
        value={email}
        onChange={handleChange}
      />
      <Input
        className={style.input}
        name='password'
        placeholder={passwordText}
        type='password'
        value={password}
        onChange={handleChange}
      />
      {state === STATES.HAS_ERROR && <p className={style.error}>{errorText}</p>}
      <p className={style.forgotPassword}>
        <a href='https://www.crossfit.com/cf/login?returnTo=%2F#forgot'>
          {forgotPasswordText}
        </a>
      </p>
      <Button type='submit'>{buttonText}</Button>
    </form>
  )
}

export default LoginForm
